import React from 'react';

function Home() {
  return (
    <div className="Home">
      <h2>Welcome to our page</h2>
      <p>
        Lorem ipsum dolor sit amet consectetur a
        dipisicing elit. Vitae laborum a, minima
        modi sed dolorem doloribus tenetur asperiores
        quae autem quia odit tempore cumque incidunt
        deserunt ipsa nam delectus totam odio placeat
        accusantium! Laudantium necessitatibus quis numquam.
      </p>
    </div>
  );
}

export default Home;
